// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"99":"2e10d4c02bbcd34d0114","833":"8174f139a2ce1016df8c","913":"b341157d2a7b9b0c7d78","926":"80f1bae5b34c0ed5ca2a"}[chunkId] + ".chunk.js";
};